<style  lang="scss" scoped>
.popover-icon {
    width: 20px !important;
    height: 20px !important;
    font-size: 20px;
    color: #7f7f7f;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 99;
}

.export-tips {
    font-size: 14px;
    font-weight: 400;
    color: #F5A728;
    line-height: 14px;
}

.flex {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
}

.A1 {
    color: #1A1A1A;
}

.a {
    color: rgba(66, 94, 178, 1);
    cursor: pointer;
}

.project_summary {
    background: #FFFFFF;
    opacity: 1;
    padding: 20px;
}

.content {
    opacity: 1;
    padding-bottom: 0;
    display: grid;
    grid-template-columns: 58% 40%;
    grid-column-gap: 20px;
    min-width: 1200px;

    .content-left {
        padding: 20px;
        background: #FFFFFF;
        border-radius: 8px;
        width: 100%;

        .table {
            height: 20px;
            font-size: 20px;
            font-weight: 500;
            line-height: 20px;
            @extend .flex;
            @extend .A1;

            .table-tips {
                font-size: 16px;
                font-weight: 400;
                color: #7F7F7F;
                line-height: 16px;
                flex: 1;
                text-align: right;

                .a {
                    margin-left: 5px;
                }
            }
        }

        .tips {
            @extend .flex;
            padding: 15px;
            margin-top: 20px;
            background: #FFF8EE;
            border-radius: 4px;
            color: #F5A728;

            .icon {
                width: 18px;
                height: 18px;
                margin-right: 6px;
                font-size: 18px;
            }

            .a {
                margin: 0 5px;
            }
        }

        .step1 {
            padding: 20px;
            border-radius: 8px;
            border: 1px solid #E8E8E8;
            margin-top: 20px;

            .table {
                font-size: 18px;
                font-weight: 700;

                .step {
                    margin-right: 13px;
                    font-weight: 800;
                    position: relative;
                    text-indent: 2px;
                    font-style: italic;
                    font-family: Avenir-Black Oblique, Avenir;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 10px;
                        background: linear-gradient(270deg, #00C4A1 0%, #E2F1E2 99%);
                        border-radius: 0px 0px 0px 0px;
                        opacity: 0.3;
                    }
                }
            }

            .p {
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #7F7F7F;
                line-height: 22px;
                margin-top: 11px;
            }

            .form {
                @extend .flex;
                margin-top: 20px;

                .form-item {
                    margin-left: 20px;

                    &:nth-of-type(1) {
                        margin: 0;
                    }

                    .el-select {
                        margin-left: 10px;
                    }
                }
            }

            .btn {
                margin-top: 20px;
            }
        }

        .step2 {
            @extend .step1;
        }

        .step3 {
            @extend .step1;
        }
    }

    .content-right {
        @extend .content-left;

        .form .form-item {
            @extend .flex;
            margin-bottom: 20px;

            .el-select {
                flex: 1;
                margin-left: 10px;
            }
        }

        .p {
            margin-bottom: 20px;
        }

        .tabs {
            margin-top: 20px;

            .el-table {
                margin-top: 20px;
            }
        }
    }
}

.upload-demo {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
}

.select {
    ::v-deep .el-tag {
        &.el-tag--info {
            border: 1px solid #1A1A1A;
            color: #1A1A1A;
            background: #F8F8F8;
        }

        // .el-tag__close {
        //     position: relative;
        //     right: initial;
        //     top: initial;
        //     color: #909399;
        //     background: none;
        //     z-index: 99;
        // }
    }

    ::v-deep .el-input__inner {
        color: #1A1A1A;
    }
}

::v-deep .el-tag--select .el-tag__close {
    position: relative;
    right: initial;
    top: initial;
    color: #909399;
    background: none;
    z-index: 99;
}

.el-checkbox {
    text-align: right;
    width: 100%;
    padding-right: 10px;
    justify-content: right;
    box-sizing: border-box;
}
</style>
<template>
    <div class="box">
        <div class="content">
            <div class="content-left">
                <div class="table">
                    发货步骤
                    <div class="table-tips">
                        请按步骤指引完成批量邮寄或虚拟发货<a class="a"
                            href="https://zhongchou.modian.com/helpcenter/qcategory?cid=5&init_id=120"
                            target="_bank">查看教程</a>
                    </div>
                </div>
                <div class="tips">
                    <el-icon class="icon">
                        <WarningFilled />
                    </el-icon>
                    发货提示：只有当所有订单都确认"全部发货"，才会为您推进众筹中款结算流程
                </div>
                <div class="step1">
                    <div class="table">
                        <div class="step">Step1</div>
                        导出待发货订单
                    </div>
                    <div class="p">1.发货前审核退款订单：批量发货不包含退款 / 申诉待审核订单，需先处理 “售后管理” 中相关状态订单。<br>2.解锁工具使用提示：导出回报档时自动包含用户已达成的解锁福利订单，请注意核对。</div>
                    <div class="form">
                        <div class="form-item">
                            <label>
                                选择发货档位
                            </label>
                            <el-select class="select" v-model="state.reward_ids" popper-class="select-pop" clearable
                                tag-type="select" collapse-tags-tooltip multiple collapse-tags :max-collapse-tags="2"
                                placeholder="请选择发货档位">
                                <el-checkbox v-model="selectAllChecked" @change="selectAll('')">全选</el-checkbox>
                                <el-option v-for="item in getSuccinctRewardListData" :key="item.id" :label="item.title"
                                    :value="item.id" />
                            </el-select>
                        </div>
                        <div class="form-item">
                            <label>
                                选择订单排序方式
                            </label>
                            <el-select class="select" v-model="state.sort" placeholder="请选择订单排序方式">
                                <el-option label="按下单时间排列订单" :value="0" />
                                <el-option label="按用户ID排列订单" :value="1" />
                            </el-select>
                        </div>
                    </div>
                    <el-popover class="popover" placement="right" :width="400" :visible="step1Pop" trigger="click">
                        <template #reference>
                            <el-button class="btn" type="primary" @click="exportExcex">导出发货订单</el-button>
                        </template>
                        <el-icon class="popover-icon" @click="step1Pop = false">
                            <Close />
                        </el-icon>
                        <el-progress :percentage="state.exportExcexRate" />
                        <div class="export-tips">导出完成前，请不要关闭当前网页</div>
                    </el-popover>
                    <el-popover class="popover" placement="right" :width="400" :visible="step1PopErp" trigger="click">
                        <template #reference>
                            <el-button class="btn" type="primary" @click="exportExcex('erp')">导出旺店通发货单</el-button>
                        </template>
                        <el-icon class="popover-icon" @click="step1PopErp = false">
                            <Close />
                        </el-icon>
                        <el-progress :percentage="state.exportExcexRate" />
                        <div class="export-tips">导出完成前，请不要关闭当前网页</div>
                    </el-popover>
                </div>
                <div class="step2">
                    <div class="table">
                        <div class="step">Step2</div>
                        录入完整的发货信息
                    </div>
                    <div class="p">导出发货单后，请详细阅读表单“sheet 1” 中的操作指南，不要更改文件及表头。</div>
                </div>
                <div class="step3">
                    <div class="table">
                        <div class="step">Step3</div>
                        上传发货单
                    </div>
                    <div class="p">上传文件必须是在“步骤1”导出并录入的发货订单。单次最多支持 5000 条订单，超过请分批上传。</div>
                    <el-popover class="popover" placement="right" :width="400" :visible="step3Pop" trigger="click">
                        <template #reference>
                            <el-button class="btn" @click="uploadRefOpen" type="primary">批量上传发货</el-button>
                        </template>
                        <el-icon class="popover-icon" @click="step3Pop = false">
                            <Close />
                        </el-icon>
                        <timeline class="timeline" :list="state.stepTimeLine" />
                    </el-popover>
                </div>
            </div>
            <div class="content-right">
                <div class="table">
                    全部发货的确认
                </div>
                <div class="tips">
                    <el-icon class="icon">
                        <WarningFilled />
                    </el-icon>
                    <template v-if="state.currentTabIndex === 1">
                        1.请确认您选择的回报档所有回报品均已发放完毕再进行此操作;<br />
                        2.确认全部发货后您选择的回报档对应订单都将变更为全部发货;<br />
                        3.订单状态变更为全部发货后，用户将进入确认收货并评价阶段;<br />
                        4.所有档位订单均完成全部发货后，您将进入众筹中款结算流程;<br />
                        5.此操作不可逆，请谨慎操作;
                    </template>
                    <template v-else>
                        1.在左侧发货步骤Step1按条件导出条发货订单表格;<br />
                        2.请仔细检查表格内容，只保留当前已部分发货的订单，请删除表格中未发货和已全部发货的订单号。<br />
                        3.点击下方的上传文件按钮，上传已处理好的表格。系统将进行检查，确保无误后开始处理。<br />
                        4.处理完成后，订单状态将更新为全部发货，并进入确认收货和评价阶段。<br />
                        !!!!请注意：该功能仅用于将表格内的订单状态从部分发货变更为全部发货，并不提供更新表格内订单发货信息的功能。
                    </template>
                </div>
                <el-tabs class="tabs" v-model="state.currentTabIndex" type="card">
                    <el-tab-pane label="按回报档" :name="1">
                        <div class="form">
                            <div class="form-item">
                                <label>
                                    选择已全部发货的档位
                                </label>
                                <el-select v-model="state.rewardIds" class="select" clearable tag-type=""
                                    collapse-tags-tooltip multiple collapse-tags :max-collapse-tags="2"
                                    placeholder="请选择已全部发货档位">
                                    <el-checkbox v-model="selectAllCheckedRight"
                                        @change="selectAll('right', state.rewardIds)">全选</el-checkbox>
                                    <el-option v-for="item in getSuccinctRewardListData" :key="item.id" :label="item.title"
                                        :value="item.id" />
                                </el-select>
                            </div>
                            <el-popover class="popover" placement="right-start" :width="300" :visible="rightPop"
                                trigger="click">
                                <template #reference>
                                    <el-button class="btn" @click="rightOpen" type="primary">确认全部发货</el-button>
                                </template>
                                <el-icon class="popover-icon" @click="rightPop = false">
                                    <Close />
                                </el-icon>
                                <timeline class="timeline" :list="state.stepTimeLineRight" />
                            </el-popover>
                        </div>
                        <el-table :data="QueryEewardAllDeliverRecordList" style="width: 100%">
                            <el-table-column prop="deliverTime" label="发货时间" />
                            <el-table-column prop="rewardNames" label="回报档" />
                            <el-table-column prop="content" label="状态">
                                <template #default="scope">
                                    <p>{{ scope.row.content }}</p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="按订单" :name="2">
                        <!-- <div class="p">按发货模版上传文件，上传后系统将按摩点订</div> -->
                        <el-button v-if="state.updateOrderDestroy" class="btn" @click="rightOrderOpen"
                            type="primary">上传文件</el-button>
                        <div v-if="!state.updateOrderDestroy" class="timeline-box">
                            <timeline class="timeline" :list="state.stepTimeLineOrderRight" />
                        </div>
                        <el-button v-if="state.resetOrderBtn" class="btn" @click="rightOrderOpen"
                            type="primary">重新上传</el-button>
                        <el-button v-else-if="!state.updateOrderDestroy && state.stepTimeLineOrderRight.length != 3"
                            @click="confirmOrderForShipment" class="btn" type="primary">确认全部发货</el-button>
                        <el-button v-else-if="!state.updateOrderDestroy" @click="() => {
                                stepTimeLineOrderRight = [
                                    { content: '文件已上传', type: 'success', htmlStr: '', rate: 0 },
                                    { content: '文件检查', type: 'info', htmlStr: '', rate: 0 }
                                ];
                                state.updateOrderDestroy = true
                            }" class="btn" type="primary">确认</el-button>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-upload class="upload-demo" v-if="state.updateDestroy" :file-list="state.fileList" ref="upload"
                accept=".xls,.xlsx" :on-change="changeUpload" action="" :auto-upload="false">
            </el-upload>
            <el-upload class="upload-order" v-if="state.updateOrderDestroy || state.resetOrderBtn"
                :file-list="state.fileList" accept=".xls,.xlsx" :on-change="changeOrderUpload" action=""
                :auto-upload="false">
            </el-upload>
        </div>
    </div>
</template>
  
<script setup>
import tools from '@/utils/tools.js'
import {
    ref,
    // eslint-disable-next-line no-unused-vars
    watchEffect,
    onBeforeMount,
    // eslint-disable-next-line no-unused-vars
    onMounted,
    reactive,
    // eslint-disable-next-line no-unused-vars
    defineExpose,
    // eslint-disable-next-line no-unused-vars
    computed,
    onBeforeUnmount,
    nextTick
} from "vue";
// eslint-disable-next-line no-unused-vars
import {
    QueryEewardAllDeliverRecord, getSuccinctRewardList, xlsxUpload,
    mdlogisticsOrderDeliver, orderQueryDeliver, rewardAllDeliver, queryRewardAllDeliver,
    batch_modify_deliver_status_check, query_batch_modify_deliver_status,
    batch_modify_deliver_status_exec, deliverDownload,
    queryDeliverDownload,
    deliverDownloadErp
} from '@/api/index';
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import timeline from "./timeline.vue"
// eslint-disable-next-line no-unused-vars
import { ElMessage, ElMessageBox } from "element-plus";
// eslint-disable-next-line no-unused-vars
const store = useStore();
// eslint-disable-next-line no-unused-vars
const router = useRouter();
const route = useRoute();
const QueryEewardAllDeliverRecordList = ref([])
const getSuccinctRewardListData = ref([])
const pro_id = route.params.id
const upload = ref({})
const step1Pop = ref(false)
const step1PopErp = ref(false)
const step3Pop = ref(false)
const rightPop = ref(false)
const rightOrderPop = ref(false)
const selectAllChecked = ref(false)
const selectAllCheckedRight = ref(false)


// const observer = null
onBeforeMount(async () => {
    // getReviceWay()
    getSuccinctReward()
    getQueryEewardAllDeliverRecord()
});
onBeforeUnmount(() => {
    stop()
});
// eslint-disable-next-line no-unused-vars
const state = reactive({
    updateDestroy: true,
    updateOrderDestroy: true,
    exportExcexRate: 0,
    fileList: [],
    rewardIds: [],
    reward_ids: [],
    checkKey: [],
    order: {
        file_path: '',
        checkKey: ''
    },
    stepTimeLine: [
        { content: '上传发货单', type: 'info', errors: [], rate: 0 },
        { content: '检查发货单', type: 'info', htmlStr: '', rate: 0 },
        { content: '开始发货', type: 'info', errors: [], rate: 0 },
    ],
    stepTimeLineRight: [
        { content: '发货状态已上传', type: 'info', htmlStr: '', rate: 0 },
        { content: '完成发货', type: 'info', htmlStr: '', rate: 0 }
    ],
    stepTimeLineOrderRight: [
        { content: '文件已上传', type: 'success', htmlStr: '', rate: 0 },
        { content: '文件检查', type: 'info', htmlStr: '', rate: 0 }
    ],
    loading: false,
    tabDisabled: false,
    submitTxt: '提交审核',
    currentTabIndex: 1,
    tabActiveName: '1',
    wb_logo_1: '',
    sort: null,
    rate_status: -1,
    rate: '',
    new_rate: '',
    tips: '<p style="width:635px;">独家销售期，系指项目众筹成功后，摩点及其关联方就主要回报产品在摩点商城及其自营渠道开展独家销售的期限，具体期限应自众筹成功之日（即项目众筹期限届满且达到众筹目标之日）或双方另行确认之日起算。</p>',
    rate_options: [],
    sales_list: [],
    rate_log: [],
    log_page: 1,
    log_total: 0,
    tipsChecked: false,
    tipShow: false,
    deliverWait: 1000,
    step1TimeOut: null,
    step2TimeOut: null,
    successCount: 0,
    errorCount: 0,
    errorExcelUrl: '',
    longtime: 0,
    resetOrderBtn: false,
    fileTempPath: '', // 暂存已上传的文件路径
    // giveaway_type_checked:false,
})
// 福利获得方式
// const getReviceWay = async () => {
//     const {status, data, message} = await getGoalGiveaway({
//         pro_id
//     });
//     if(status == 0){
//         if(data.giveaway_type > 0){
//             state.giveaway_type_checked = true;
//         }
//         getSuccinctReward()
//     }else{
//         tools.confirm(message);
//     }
// }
const getSuccinctReward = async () => {
    let { data } = await getSuccinctRewardList({
        pro_id
    })
    // if(state.giveaway_type_checked){
    //     data.unshift({
    //         id: 1,
    //         title: '解锁福利回报档'
    //     })
    // }
    getSuccinctRewardListData.value = data
}
const stop = watchEffect(() => {
    if (state.rewardIds.length !== getSuccinctRewardListData.value.length) {
        selectAllCheckedRight.value = false
    } else {
        selectAllCheckedRight.value = true
    }
    if (state.reward_ids.length !== getSuccinctRewardListData.value.length) {
        selectAllChecked.value = false
    } else {
        selectAllChecked.value = true
    }
})
const selectAll = (str) => {
    if (str === 'right') {
        state.rewardIds = []
        if (selectAllCheckedRight.value) {
            getSuccinctRewardListData.value.forEach(e => {
                state.rewardIds.push(e.id)
            })
        }
    } else {
        state.reward_ids = []
        if (selectAllChecked.value) {
            getSuccinctRewardListData.value.forEach(e => {
                state.reward_ids.push(e.id)
            })
        }
    }


}
// eslint-disable-next-line no-unused-vars
const changeStatus = item => {
    if (item.disabled) {
        return false;
    }
    state.currentTabIndex = item.status
}
// 导出发货单
const exportExcex = async (str) => {
    if (!state.reward_ids.length) {
        return ElMessageBox.confirm(
            "请选择发货档位",
            "提示",
            {
                autofocus: false,
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
            }
        )
    }
    if (state.sort === null) {
        return ElMessageBox.confirm(
            "请选择订单排序方式",
            "提示",
            {
                autofocus: false,
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
            }
        )
    }
    if (state.longtime !== 0) { throw new Error('') } else {
        state.exportExcexRate = 0
    }
    let item = null
    if (str === 'erp') {
        step1PopErp.value = true
        item = await deliverDownloadErp({
            pro_id,
            sort: state.sort,
            reward_ids: state.reward_ids.join(','),
            erp_type: 'wdt'
        })
    } else {
        step1Pop.value = true
        item = await deliverDownload({
            pro_id,
            sort: state.sort,
            reward_ids: state.reward_ids.join(','),
        })
    }
    get_deliver_time();
    async function get_deliver_time() {
        const data = await queryDeliverDownload({ pro_id, check_key: item.checkKey })
        state.exportExcexRate = data.rate
        if (data && data.rate != 100) {
            state.longtime += state.deliverWait
            state.step1TimeOut = setTimeout(() => {
                get_deliver_time();
            }, state.deliverWait);
        }
        if (data.rate == 100 || state.longtime > 60000) {
            state.longtime = 0
            state.exportExcexRate = 0
            step1Pop.value = false
            step1PopErp.value = false
            if (data.downloadUrl) {
                let arr = data.downloadUrl.split('/')
                let name = arr[arr.length - 1]
                tools.downLoadUrl(data.downloadUrl, name)
            }
            // window.open(data.downloadUrl, `arget`)
            clearTimeout(state.step1TimeOut);
        }
    }
}
// 回报档发货按钮
const rightOpen = () => {
    if (!rightPop.value) {
        if (state.rewardIds.length) {
            let html = '<p>请再次确认以下档位是否已全部完成发货，判定为全部发货状态后，不可再进行订单发货信息更新。此操作不可逆。</p>'
            state.rewardIds.forEach(e => {
                const obj = getSuccinctRewardListData.value.filter(r => r.id === e)
                html += `<li>${obj[0].title}</li>`
            })
            ElMessageBox.confirm(
                html,
                "重要提示：",
                {
                    autofocus: false,
                    showCancelButton: true,
                    dangerouslyUseHTMLString: true,
                    cancelButtonText: "取消",
                    confirmButtonText: "确认",
                }
            ).then(() => {
                rewardAllDeliverFn()
            });
        } else {
            ElMessageBox.confirm(
                '请选择已全部发货档位',
                "提示",
                {
                    autofocus: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确认",
                }
            ).then(() => {
            });
        }
    }
}
// 按订单上传文件
const rightOrderOpen = () => {
    rightOrderPop.value = true
    document.querySelector(".upload-order input").click()
}
const uploadRefOpen = () => {
    if (!step3Pop.value) {
        ElMessageBox.confirm(
            '若某回报档内所有物品均已完成发货，请您及时将对应档位状态变更为 <全部发货>',
            "重要提示：",
            {
                autofocus: false,
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "还需要继续发货",
            }
        ).then(() => {
            if (state.updateDestroy) {
                document.querySelector(".upload-demo input").click()
            } else {
                step3Pop.value = true
            }
        });
    }
}

// 订单上传文件
const changeOrderUpload = async (file, fileList) => {
    fileList.splice(0, 1)
    const { data: { file_path } } = await postUpload(file.raw)
    state.updateOrderDestroy = false
    state.resetOrderBtn = true
    state.stepTimeLineOrderRight[0].content = '文件上传中'
    state.stepTimeLineOrderRight[0].type = 'success'
    const { checkKey } = await batch_modify_deliver_status_check({
        proId: pro_id,
        filePath: file_path,
        type: 'md_modify_status'
    })
    state.stepTimeLineOrderRight[0].content = '文件已上传'
    state.stepTimeLineOrderRight[0].type = 'success'
    state.order.file_path = file_path
    state.order.checkKey = checkKey
    state.resetOrderBtn = false
    get_deliver_time();
    async function get_deliver_time() {
        const data = await query_batch_modify_deliver_status({ type: 'md_modify_status', checkKey })
        if (data.errors) {
            state.stepTimeLineOrderRight[0].type = 'danger'
            let htmlStr = ''
            data.errors.forEach((element, idx) => {
                htmlStr += `<p>${idx + 1}.${element}</p>`
            });
            state.stepTimeLineOrderRight[0].htmlStr = htmlStr
            if (data.nodeIndex == 1) {
                state.stepTimeLineOrderRight[0].content = '系统检查Excel未通过'
            } else {
                state.stepTimeLineOrderRight[1].content = '发货失败'
            }
            state.resetOrderBtn = true
            clearTimeout(state.step2TimeOut);
            return false;
        }
        if (data.nodeIndex == 1) {
            state.stepTimeLineOrderRight[1].content = '系统正在检查Excel'
            state.stepTimeLineOrderRight[1].type = 'success';
            state.stepTimeLineOrderRight[1].rate = data.rate;
            if (data.rate == 100) {
                state.stepTimeLineOrderRight[1].content = '系统已检查'
                state.stepTimeLineOrderRight[1].htmlStr = `本次共${data.successCount}笔订单待确认全部发货`
                return clearTimeout(state.step2TimeOut);
            }
        }
        if (data.nodeIndex == 2) {
            state.stepTimeLineOrderRight[0].content = '系统已检查Excel';
            state.stepTimeLineOrderRight[0].type = 'success';
            state.deliverWait = 3000;
            state.stepTimeLineOrderRight[0].rate = data.rate;
        }
        if (data && !(data.rate == 100 && data.nodeIndex == 2)) {
            state.step2TimeOut = setTimeout(() => {
                get_deliver_time();
            }, state.deliverWait);
        }
        if (data.rate == 100 && data.nodeIndex == 2) {
            clearTimeout(state.step2TimeOut);
            state.stepTimeLineOrderRight[1].content = '发货成功';
            state.stepTimeLineOrderRight[1].type = 'success';
            let tipsStr = ''
            if (Number(data.errorCount > 0)) {
                tipsStr = `<p>发货成功${data.successCount}条，发货失败${data.errorCount}条</p>`;
            } else {
                tipsStr = `<p>发货成功${data.successCount}条</p>`
            }
            if (data.errorExcelUrl) {
                tipsStr += `<p>请重新上传发货失败的订单</p><p><a href="${data.errorExcelUrl}" target="_blank">导出失败列表</a></p>`
            }
            ElMessageBox.confirm(
                tipsStr,
                "提示",
                {
                    autofocus: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                }
            ).then(() => { });
        }
    }
}

// 批量上传发货
const changeUpload = async (file, fileList) => {
    fileList.splice(0, 1)
    const { data: { file_path } } = await postUpload(file.raw)
    state.fileTempPath = file_path;
    console.log('fahuo')
    afterUpload(file_path)
}
// 文件上传成功后的过程
const afterUpload = async (file_path) => {
    const { checkKey } = await mdlogisticsOrderDeliver({
        proId: pro_id,
        filePath: file_path ? file_path : state.fileTempPath,
        type: 'md',
        force: file_path ? 0 : 1
    })
    state.stepTimeLine = [
        { content: '上传发货单', type: 'info', errors: [], rate: 0 },
        { content: '检查发货单', type: 'info', htmlStr: '', rate: 0 },
        { content: '开始发货', type: 'info', errors: [], rate: 0 },
    ]
    state.updateDestroy = false
    step3Pop.value = true
    state.stepTimeLine[0].content = '发货单已上传'
    state.stepTimeLine[0].type = 'success'
    get_deliver_time();
    async function get_deliver_time() {
        const data = await orderQueryDeliver({ type: 'md', checkKey })
        if (data.warns && data.warns.length > 0) {
            state.updateDestroy = true
            clearTimeout(state.step2TimeOut);
            let warnStr = ''
            data.warns.forEach((element, idx) => {
                warnStr += `<p>${idx + 1}.${element}</p>`
            });
            ElMessageBox.confirm(
                warnStr,
                "提示",
                {
                    autofocus: false,
                    showCancelButton: true,
                    dangerouslyUseHTMLString: true,
                    cancelButtonText: "取消发货",
                    confirmButtonText: "忽略并继续发货",
                }
            ).then(() => {
                afterUpload(null)
            }).catch(() => {
                step3Pop.value = false
            })
            return false;
        }
        if (data.errors && data.errors.length > 0) {
            state.updateDestroy = true
            state.stepTimeLine[1].type = 'danger'
            let htmlStr = ''
            data.errors.forEach((element, idx) => {
                htmlStr += `<p>${idx + 1}.${element}</p>`
            });
            state.stepTimeLine[1].htmlStr = htmlStr
            if (data.nodeIndex == 1) {
                state.stepTimeLine[1].content = '系统检查Excel未通过'
            } else {
                state.stepTimeLine[1].content = '发货失败'
            }
            clearTimeout(state.step2TimeOut);
            return false;
        }
        if (data.nodeIndex == 1) {
            state.stepTimeLine[1].content = '系统正在检查Excel';
            state.stepTimeLine[1].rate = data.rate;
        }
        if (data.nodeIndex == 2) {
            state.stepTimeLine[1].content = '系统已检查Excel';
            state.stepTimeLine[1].type = 'success';
            state.deliverWait = 3000;
            state.stepTimeLine[1].rate = data.rate;
        }
        if (data && !(data.rate == 100 && data.nodeIndex == 2)) {
            state.step2TimeOut = setTimeout(() => {
                get_deliver_time();
            }, state.deliverWait);
        }
        if (data.rate == 100 && data.nodeIndex == 2) {
            state.updateDestroy = true
            clearTimeout(state.step2TimeOut);
            state.stepTimeLine[2].content = '发货成功';
            state.stepTimeLine[2].type = 'success';
            let tipsStr = ''
            if (Number(data.errorCount > 0)) {
                tipsStr = `<p>发货成功${data.successCount}条，发货失败${data.errorCount}条</p>`;
            } else {
                tipsStr = `<p>发货成功${data.successCount}条</p>`
            }
            if (data.errorExcelUrl) {
                tipsStr += `<p>请重新上传发货失败的订单</p><p><a href="${data.errorExcelUrl}" target="_blank">导出失败列表</a></p>`
            }
            step3Pop.value = true
            ElMessageBox.confirm(
                tipsStr,
                "提示",
                {
                    autofocus: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                }
            ).then(() => { });
        }
    }
}
// 订单确认发货
const confirmOrderForShipment = async () => {
    if (state.stepTimeLineOrderRight.length > 3) return
    state.stepTimeLineOrderRight.push(
        { content: '订单发货', type: 'info', htmlStr: '', rate: 0 }
    )
    await nextTick()
    const { checkKey } = await batch_modify_deliver_status_exec({
        proId: pro_id,
        filePath: state.order.file_path,
        type: 'md_modify_status',
        checkKey: state.order.checkKey
    })
    get_deliver_time();
    async function get_deliver_time() {
        const data = await query_batch_modify_deliver_status({ type: 'md_modify_status', checkKey })
        if (data.nodeIndex == 2) {
            state.stepTimeLineOrderRight[2].content = '系统已检查Excel';
            state.stepTimeLineOrderRight[2].type = 'success';
            state.deliverWait = 3000;
            state.stepTimeLineOrderRight[2].rate = data.rate;
        }
        if (data && !(data.rate == 100 && data.nodeIndex == 2)) {
            state.step2TimeOut = setTimeout(() => {
                get_deliver_time();
            }, state.deliverWait);
        }
        if (data.rate == 100 && data.nodeIndex == 2) {
            clearTimeout(state.step2TimeOut);
            state.stepTimeLineOrderRight[2].content = '发货成功';
            state.stepTimeLineOrderRight[2].type = 'success';
            let tipsStr = ''
            if (Number(data.errorCount > 0)) {
                tipsStr = `<p>发货成功${data.successCount}条，发货失败${data.errorCount}条</p>`;
            } else {
                tipsStr = `<p>发货成功${data.successCount}条</p>`
            }
            if (data.errorExcelUrl) {
                tipsStr += `<p>请重新上传发货失败的订单</p><p><a href="${data.errorExcelUrl}" target="_blank">导出失败列表</a></p>`
            }
            ElMessageBox.confirm(
                tipsStr,
                "提示",
                {
                    autofocus: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                }
            ).then(() => { });
        }
    }
}
//按回报档确认发货
const rewardAllDeliverFn = async () => {
    const { checkKey } = await rewardAllDeliver({
        proId: pro_id,
        rewardIds: state.rewardIds.join(','),
        type: 'md'
    })
    rightPop.value = true
    get_deliver_time();
    async function get_deliver_time() {
        const data = await queryRewardAllDeliver({ type: 'md', checkKey })
        if (data.errors) {
            state.stepTimeLineRight[0].type = 'danger'
            let htmlStr = ''
            data.errors.forEach((element, idx) => {
                htmlStr += `<p>${idx + 1}.${element}</p>`
            });
            state.stepTimeLineRight[0].htmlStr = htmlStr
            if (data.nodeIndex == 1) {
                state.stepTimeLineRight[0].content = '系统检查Excel未通过'
            } else {
                state.stepTimeLineRight[0].content = '发货失败'
            }
            clearTimeout(state.step2TimeOut);
            return false;
        }
        if (data.nodeIndex == 2) {
            state.stepTimeLineRight[0].content = '开始发货';
            state.stepTimeLineRight[0].type = 'success';
            state.stepTimeLineRight[0].rate = data.rate;
        }
        if (data && !(data.rate == 100 && data.nodeIndex == 2)) {
            state.step2TimeOut = setTimeout(() => {
                get_deliver_time();
            }, state.deliverWait);
        }
        if (data.rate == 100 && data.nodeIndex == 2) {
            clearTimeout(state.step2TimeOut);
            state.stepTimeLineRight[1].content = '发货成功';
            state.stepTimeLineRight[1].type = 'success';
            let tipsStr = ''
            if (Number(data.errorCount > 0)) {
                tipsStr = `<p>确认发货成功${data.successCount}条，确认发货失败${data.errorCount}条</p>`;
            } else {
                tipsStr = `<p>确认发货成功${data.successCount}条</p>`
            }
            if (data.errorExcelUrl) {
                tipsStr += `<p>请重新上传发货失败的订单</p><p><a href="${data.errorExcelUrl}" target="_blank">导出失败列表</a></p>`
            }
            ElMessageBox.confirm(
                tipsStr,
                "提示",
                {
                    autofocus: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                }
            ).then(() => { });
        }
    }
}

// eslint-disable-next-line no-unused-vars
const postUpload = async (file) => {
    try {
        const data = await xlsxUpload({ file })
        return data
    } catch (e) {
        return ElMessage({
            type: 'warning',
            customClass: 'waring-customize',
            message: e,
        })
    }
}
const getQueryEewardAllDeliverRecord = async () => {
    let data = await QueryEewardAllDeliverRecord({
        proId: pro_id,
        type: 'md'
    })
    QueryEewardAllDeliverRecordList.value = data.list
}

// eslint-disable-next-line no-unused-vars
function reset() {
    state.stepTimeLine = [
        { content: '上传发货单', type: 'info', errors: [], rate: 0 },
        { content: '检查发货单', type: 'info', htmlStr: '', rate: 0 },
        { content: '开始发货', type: 'info', errors: [], rate: 0 },
    ]
    state.stepTimeLineRight = [
        { content: '发货状态已上传', type: 'info', htmlStr: '', rate: 0 },
        { content: '完成发货', type: 'info', htmlStr: '', rate: 0 }
    ]
    state.stepTimeLineOrderRight = [
        { content: '文件已上传', type: 'success', htmlStr: '', rate: 0 },
        { content: '文件检查', type: 'info', htmlStr: '', rate: 0 }
    ]
}

// eslint-disable-next-line no-unused-vars
const tipsChange = () => {
    if (state.tipsChecked) {
        state.tipShow = false;
    }
}
</script>

  